<template>
  <!--
  -->
  <div class="pb50" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--基础设置-->
      <Basic :form="form" :gradeList="gradeList" :app_id="app_id" :category="category" :is_edit="is_edit"></Basic>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import SupplyApi from '@/api/supply.js';
import Basic from './part/Basic.vue';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
    /*基础设置*/
    Basic,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
       form: {
        image_id: 0,
        kmd_grade_id:0,
        /*名称*/
        name: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        // 是否自营
        self_manage: 0,
        user_id:'',
        user_name:'',
        password:'',
        introduce:'',
        remark:'',
        /*默认排序*/
        sort: 100,
        is_forbidden_buy:0,
        product_show:'two_column',
        notice:"",
        uname:"",
        image_url:"",
        audit_status:0,
        reject_reason:""
      },
       gradeList: [],
       app_id:0,
       is_edit:true,
      category:[]
    };
  },
  created() {
    /*获取列表*/
    this.form.supply_id = this.$route.query.supply_id;
    this.getData();
     this.getGradeList();
  },
  methods: {



    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      SupplyApi.getSupply({supply_id:self.form.supply_id}, true)
        .then(res => {
          let tempForm=res.data.detail;
          tempForm.supply_id = self.form.supply_id;

          self.form = tempForm;
          self.form.file_path = tempForm.image_url;
          self.form.user_name = tempForm.shop_user.user_name;
          self.form.notice =  tempForm.shop_user.notice+"";
          if(self.form.product_show==''||self.form.product_show==undefined){
             self.form.product_show = 'two_column';
          }
          self.loading = false;
        })
        .catch(error => {});
    },
    /*获取角色列表*/
      getGradeList() {
        // console.log(444);return
         SupplyApi.gradeLists('', true)
          .then(res => {
            this.gradeList = res.data.list.data;
            this.app_id = res.data.app_id;
            this.category = res.data.category;
          })
          .catch(error => {

          });
      },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let params = self.form;
          delete params.tableData;
          SupplyApi.saveSupply(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },



    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/edit.vue